import { Component, Input } from '@angular/core';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { MediaModalComponent } from 'src/app/shared/components/media-modal/media-modal.component';
import { PictureModalComponent } from 'src/app/shared/components/picture-modal/picture-modal.component';
import { API_URL_PREFIX, BasicService } from 'src/app/shared/services/basic.service';
import { MediasService } from 'src/app/shared/services/medias.service';
import { Attachment, Task } from 'src/app/tasks/shared/models';

@Component({
  selector: 'app-task-attachments',
  templateUrl: './task-attachments.component.html',
  styleUrls: ['./task-attachments.component.scss'],
})
export class TaskAttachmentsComponent {
  @Input() task: Task;
  baseUrl: string;

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private basicService: BasicService,
    private mediasService: MediasService
  ) {
    this.baseUrl = `${API_URL_PREFIX}/${this.alcmeonContextService.getCompany().id}/message-attachments/`;
  }

  viewPicture(mediaIndex: string) {
    this.basicService.modal({
      component: PictureModalComponent,
      componentProps: {
        src: `${this.baseUrl}${mediaIndex}`,
      },
    });
  }

  viewMedia(mediaIndex: string, type: string) {
    this.basicService.modal({
      component: MediaModalComponent,
      componentProps: {
        src: `${this.baseUrl}${mediaIndex}`,
        type: type,
      },
      cssClass: 'app-media-modal',
    });
  }

  downloadFile(attachment: Attachment) {
    this.alcmeonContextService.addJwtShortToUrl(this.baseUrl + attachment.message_index).subscribe(url => {
      this.mediasService.downloadFile(url, attachment.name);
    });
  }
}
